// Active peers without the subject unit, and their averages (QA P-1 and the
// re-test). Pure: no API client, shared by the Comps and Intelligence tabs
// of both designs.
/**
 * Active peers without the unit itself (QA P-1: the backend's peer list can
 * contain the subject stock number, so a unit showed up as its own peer).
 * Compared as strings: the payload and the inventory differ in type.
 */
export const excludeSubject = (peers, stockNumber) => (Array.isArray(peers) ? peers : [])
    .filter((p) => String(p?.stock_number ?? '').trim() !== String(stockNumber ?? '').trim());

const summarise = (vals) => (vals.length
    ? { avg: vals.reduce((a, b) => a + b, 0) / vals.length, min: Math.min(...vals), max: Math.max(...vals), count: vals.length }
    : null);

/**
 * The peer averages for what is shown: computed from the peer rows without
 * the unit itself (QA re-test: the backend's hours_summary and
 * listing_duration_summary count the subject when it is in its own peer
 * list), with the backend's rules: hours > 0, MachineFinder days listed when
 * present. Falls back to the backend figures when there are no rows to
 * compute from (an older payload, or no peers).
 */
export const peerSummaries = (comps, stockNumber) => {
    const backend = {
        hours_summary: comps?.hours_summary || null,
        listing_duration_summary: comps?.listing_duration_summary || null,
    };
    const peers = excludeSubject(comps?.active_peers, stockNumber);
    if (!peers.length) return backend;
    const num = (v) => (typeof v === 'number' && Number.isFinite(v) ? v : null);
    const hours = peers.map((p) => num(p.hours)).filter((v) => v != null && v > 0);
    const listed = peers.map((p) => num(p.mf_days_listed)).filter((v) => v != null);
    return {
        hours_summary: hours.length ? summarise(hours) : (peers.some((p) => 'hours' in p) ? null : backend.hours_summary),
        listing_duration_summary: listed.length
            ? summarise(listed)
            : (peers.some((p) => 'mf_days_listed' in p) ? null : backend.listing_duration_summary),
    };
};
